/**
 * Bucks (header EUR flag) only converts price. Country stays put, so stock-ar
 * still looks in stock. EUR → eu and ARS → ar, via cart attribute `_stock_region`.
 */
(function () {
  if (window.Shopify && Shopify.designMode) return;

  const map = { EUR: 'eu', ARS: 'ar' };
  let started = false;

  function readCurrency() {
    for (const store of [sessionStorage, localStorage]) {
      const raw = store.getItem('buckscc_customer_currency');
      if (!raw) continue;
      try {
        const parsed = JSON.parse(raw);
        if (parsed) return String(parsed).toUpperCase();
      } catch {
        return raw.replace(/"/g, '').toUpperCase();
      }
    }
    const label = document.querySelector('.bucks-selected');
    return (label && label.textContent.trim().toUpperCase()) || '';
  }

  function sync() {
    if (started) return;
    const code = readCurrency();
    if (!code) return;

    const root = document.documentElement;
    const desired = map[code] || '';
    const override = root.dataset.stockRegion || '';
    const computed = root.dataset.visitorRegion || '';

    if (desired) {
      if (computed === desired && (override === desired || override === '')) return;
      if (override === desired) return;
    } else if (!override) {
      return;
    }

    const guardKey = 'stock-region-sync';
    if (sessionStorage.getItem(guardKey) === desired) return;
    sessionStorage.setItem(guardKey, desired);
    started = true;

    const url = (window.Theme && Theme.routes && Theme.routes.cart_update_url) || '/cart/update';
    fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _stock_region: desired } }),
    }).then(function (response) {
      if (response.ok) location.reload();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  setTimeout(sync, 800);
})();
